var _defs, _path, _path2, _path3, _path4, _g, _path5, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 666.667,
    height: 666.667,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-380.77017 0 0 380.77017 441.976 216.584)",
    spreadMethod: "pad",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b007d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#4b007d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#913bc4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-35.33595 0 0 35.33595 440.585 284.467)",
    spreadMethod: "pad",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b007d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#4b007d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#913bc4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h500V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h500V0H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.958 158.48h344.375l17.643 63.888-221.851 1.794-65.464 50.525H61.206z",
    fill: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 666.667)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M589.301 370.176l-301.776-3.947-83.258-66.455H81.608l11.257-77.842 91.78-21.636 309.736.61 94.92 26.806z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M589.301 370.176l-301.776-3.947-83.258-66.455H81.608l11.257-77.842 91.78-21.636 309.736.61 94.92 26.806z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.33333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M489.333 196H184v-32h305.333z",
    fill: "#f0f1f3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 0 666.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.813 357.51v14.084a5.406 5.406 0 005.406 5.406h147.737M322.584 377h37.68a5.402 5.402 0 005.402-5.402V356.02M61.206 222.368v92.24c0 9.447 5.938 20.197 15.186 22.482l62.091 12.688h229.848l56.026-10.427c5.09-.947 11.584-7.775 14.253-12.212 3.722-6.188 3.356-10.83 3.356-17.579v-82.419",
    fill: "none",
    stroke: "#000",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.682 278.976h55.875c4.928 0 9.686-1.797 13.383-5.054l45.863-40.405a27.015 27.015 0 0117.686-6.746l217.487-1.403M79.959 158.848H425.81",
    fill: "none",
    stroke: "#000",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.732 165.554c0-33.012-26.762-59.773-59.774-59.773s-59.774 26.76-59.774 59.773c0 33.013 26.762 59.774 59.774 59.774s59.774-26.761 59.774-59.774",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.732 165.554c0-33.012-26.762-59.773-59.774-59.773s-59.774 26.76-59.774 59.773c0 33.013 26.762 59.774 59.774 59.774s59.774-26.761 59.774-59.774z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 14,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.843 165.554c0-11.533-9.35-20.884-20.884-20.884s-20.885 9.35-20.885 20.884 9.35 20.885 20.885 20.885c11.534 0 20.884-9.351 20.884-20.885",
    fill: "#e5f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.843 165.554c0-11.533-9.35-20.884-20.884-20.884s-20.885 9.35-20.885 20.884 9.35 20.885 20.885 20.885c11.534 0 20.884-9.351 20.884-20.885z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 14,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.107 165.554c0-33.012-26.762-59.773-59.774-59.773s-59.774 26.76-59.774 59.773c0 33.013 26.762 59.774 59.774 59.774s59.774-26.761 59.774-59.774",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.107 165.554c0-33.012-26.762-59.773-59.774-59.773s-59.774 26.76-59.774 59.773c0 33.013 26.762 59.774 59.774 59.774s59.774-26.761 59.774-59.774z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 14,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.218 165.554c0-11.533-9.35-20.884-20.885-20.884-11.533 0-20.884 9.35-20.884 20.884s9.351 20.885 20.884 20.885c11.534 0 20.885-9.351 20.885-20.885",
    fill: "#e5f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.218 165.554c0-11.533-9.35-20.884-20.885-20.884-11.533 0-20.884 9.35-20.884 20.884s9.351 20.885 20.884 20.885c11.534 0 20.885-9.351 20.885-20.885z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 14,
    strokeMiterlimit: 10
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M405.248 284.467c0-19.515 15.821-35.335 35.336-35.335v70.671c-19.515 0-35.336-15.82-35.336-35.336",
    fill: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 0 666.667)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "matrix(1.33333 0 0 -1.33333 0 666.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.584 249.131c-19.515 0-35.336 15.821-35.336 35.336 0 19.516 15.821 35.336 35.336 35.336",
    fill: "none",
    stroke: "#020202",
    strokeWidth: 14,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.126 309.251a6.655 6.655 0 10-13.31 0 6.655 6.655 0 0013.31 0M345.297 284.467a6.655 6.655 0 10-13.31 0 6.655 6.655 0 0013.31 0M379.903 284.467a6.655 6.655 0 10-13.31 0 6.655 6.655 0 0013.31 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.01d100a1a7bbb8bee90d269a9c06fc41.svg";
export { ForwardRef as ReactComponent };